export const CRISIS_RESOURCES = [
  {
    name: "988 Suicide & Crisis Lifeline",
    tel: "988",
    sms: "988",
    description: "Call or Text 988 in the US and Canada. Free, confidential, round-the-clock support for anyone — this is the right first call for most people, including teens.",
    badge: "Everyone · Start Here",
    accent: "#DC2626",
  },
  {
    name: "Teens",
    tel: "988",
    telLabel: "Call or Text 988",
    sms: "839863",
    smsLabel: "Text TEEN to 839863",
    description: "If you're a teen and struggling, call or text 988 anytime — it's free and confidential. You can also text TEEN to 839863 to reach Teen Line, where trained teen volunteers listen.",
    badge: "For Teens",
    accent: "#0D9488",
  },
  {
    name: "LGBTQ+ Young People — The Trevor Project",
    tel: "18664887386",
    smsLabel: "Text START to 678-678",
    sms: "678678",
    description: "Affirming, judgment-free crisis support created specifically for LGBTQ+ young people. Call 1-866-488-7386 or text START to 678-678, 24/7.",
    badge: "LGBTQ+ Youth",
    accent: "#6366F1",
  },
  {
    name: "Veterans Crisis Line",
    tel: "988",
    telLabel: "Dial 988 then Press 1",
    sms: "838255",
    description: "Dial 988 then press 1, or text 838255 to connect with responders dedicated to veterans & families.",
    badge: "Veterans & Families",
    accent: "#0E7490",
  },
  {
    name: "Crisis Text Line",
    smsLabel: "Text HOME to 741741",
    sms: "741741",
    description: "Text HOME to 741741 from anywhere in the US to text with a trained volunteer Crisis Counselor.",
    badge: "Text Messaging",
    accent: "#0F766E",
  },
  {
    name: "Findahelpline (Worldwide)",
    url: "https://www.findahelpline.com/",
    description: "Over 70+ verified international helplines reachable worldwide, powered by Befrienders Worldwide & IASP.",
    badge: "International",
    accent: "#B45309",
  },
];
